import React from 'react';
import PropTypes from 'prop-types';
import FullPageMessage from '../../../common/fullPageMessage/FullPageMessage';
import {
	ONBOARDING_ERROR_SUBSCRIPTION_PAUSED_TITLE,
	ONBOARDING_ERROR_SUBSCRIPTION_PAUSED_DESCRIPTION,
	ONBOARDING_ERROR_CANCELLATION_PERIOD_CTA,
} from '../../../../constants/Copy';
import { ROUTE_HOME } from '../../../../constants/Routes';

const DefaultSubscriptionPaused = (props) => (
	<FullPageMessage
		button={{
			onClick: () => props.history.push(ROUTE_HOME),
			testValue: ROUTE_HOME,
			text: ONBOARDING_ERROR_CANCELLATION_PERIOD_CTA,
		}}
		title={ONBOARDING_ERROR_SUBSCRIPTION_PAUSED_TITLE}
		description={ONBOARDING_ERROR_SUBSCRIPTION_PAUSED_DESCRIPTION}
	/>
);

DefaultSubscriptionPaused.propTypes = {
	history: PropTypes.object.isRequired,
};

export default DefaultSubscriptionPaused;
